/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import LogRocket from 'logrocket';
import moment from 'moment-timezone';
import api from '../services/api';

const abbrs = {
  EST: 'ET',
  EDT: 'ET',
  CST: 'CT',
  CDT: 'CT',
  MST: 'MT',
  MDT: 'MT',
  PST: 'PT',
  PDT: 'PT',
};

// eslint-disable-next-line func-names
moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr();
  return abbrs[abbr] || abbr;
};

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

if ((process.env.NODE_ENV || 'development') !== 'development') {
  LogRocket.init(process.env.LOGROCKET_APP_ID);
  api.user.getUserEmail()
    .then((response) => {
      LogRocket.identify(response.id.toString(), {
        name: response.full_name,
        email: response.email,
      });
    });
}
